export default __webpack_public_path__ + "static/media/finance-management.2ea93d62.svg";